'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ToggledItemsListDirective=class ToggledItemsListDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/toggledItemsList/toggledItemsListTemplate'}

get objectBindings(){return['items','selectedItems','itemFormatter']}

get controller(){return ToggledItemsListController}};let


ToggledItemsListController=class ToggledItemsListController{
toggle(item){
if(this.isSelected(item)){
_.pull(this.selectedItems,item);
}else{
this.selectedItems.push(item);
}
}

isSelected(item){
return _(this.selectedItems).includes(item);
}};


module.exports=ToggledItemsListDirective;
//# sourceMappingURL=toggledItemsListDirective.js.map
